<custom-navbar barTitle="운동기록" [showSetting]="false"></custom-navbar>
<div class="detail-wrap">
  <div class="desc-box">
    <div class="desc" *ngIf="ecNum!=1 && ecNum!=7 && ecNum!=13 && !(ecNum<=23 && ecNum>=19)">{{ecName}} - {{eName}}</div>
    <div class="desc" *ngIf="ecNum==1 || ecNum==7 || ecNum==13">안구강화 - 5가지 운동</div>
    <div class="desc" *ngIf="eNum==67 || eNum==73 || eNum==79 || eNum==84 || eNum==89">운동검사 - {{ecName}}</div>
    <div class="desc" *ngIf="eNum==68 || eNum==74 || eNum==80 || eNum==85 || eNum==90">검사운동 - {{ecName}}</div>
  </div>
  <div class="brain-box" *ngIf="ecNum!=1 && ecNum!=7 && ecNum!=13 && eNum!=67 && eNum!=73 && eNum!=79 && eNum!=84 && eNum!=89">
    <div class="background">
      <img src="assets/images/exercise_bg.png">
    </div>
    <div class="picture-wrap">
      <img class="picture" [src]="getBrainImage()">
    </div>
    <div class="exexplain-wrap">
      <div [ngClass]="ss.setBrainColor(exDetailList.b_name1)" class="exexplain1">
        <span class="tit-stimulation">{{exDetailList.b_name1}} 자극</span><p>
        <span class="desc-stimulation">{{exDetailList.bc_plain1}}</span>
      </div>
      <div [ngClass]="ss.setBrainColor(exDetailList.b_name2)" class="exexplain2">
        <span class="tit-stimulation">{{exDetailList.b_name2}} 자극</span><p>
        <span class="desc-stimulation">{{exDetailList.bc_plain2}}</span>
      </div>
    </div>
  </div>
  <!--일반 운동의 경우-->
  <div class="exinfo-box" *ngIf="ecNum!=1 && ecNum!=7 && ecNum!=13 && !(ecNum<=23 && ecNum>=19)">
    <div class="box-space"></div>
    <div [ngClass]="ss.setEcColor(ecName)" class="title">{{ecName}}</div>
    <div class="picture-wrap">
      <img class="picture" [src]="getExImage()">
    </div>
    <div class="exexplain">
      <div [ngClass]="ss.setEColor(ecName)" class="ename">{{eName}}</div>
      <div class="explain">{{exDetailList.e_explain}}</div>
    </div>
  </div>
  <!--검사 운동의 경우-->
  <div class="testexinfo-box" *ngIf="eNum==68 || eNum==74 || eNum==80 || eNum==85 || eNum==90">
    <div class="box-space"></div>
    <div [ngClass]="ss.setEcColor(ecName)" class="testex-title">{{ecName}} 운동</div>
    <div class="testex-list-box">
      <div class="wrap">
        <img [src]="requestExerciseImage(eNum)">
      </div>
    </div>
    <div class="testex-explain-wrap">
      <div [ngClass]="ss.setEColor(ecName)" class="name">{{testExName}}</div>
      <div class="explain">{{eyetestList.e_explain}}</div>
    </div>
  </div>
  <!--검사의 경우-->
  <div class="testinfo-box" *ngIf="eNum==67 || eNum==73 || eNum==79 || eNum==84 || eNum==89">
      <div class="image">
          <img [src]="requestExerciseImage(eNum)">
      </div>
      <div [ngClass]="ss.setEColor(ecName)" class="title">{{ecName}}({{exDetailList.e_ename}}) 검사란?</div>
      <div class="explain">
        <span class="desc-exercise">{{exDetailList.e_explain}}</span>
        <p>
          *참고문헌<br>
          <span *ngFor="let list of testReference">{{list}}<br></span>
        </p>
      </div>
  </div>
  <!--안구 운동의 경우-->
  <div class="eyeinfo-box" *ngIf="ecNum==1 || ecNum==7 || ecNum==13">
    <div class="eye-list" *ngFor="let eye of eyetestList let i=index">
      <div class="image"><img [src]="requestExerciseImage(eye.e_num)"></div>
      <div class="name">
        {{eye.e_ename}}{{eye.e_name == '댄싱넘버' || eye.e_name == '점핑넘버' ? '('+eye.e_name+')' : '('+eye.e_name+')이' }}란?
      </div>
      <div class="explain">{{eye.e_explain}}</div>
    </div>
  </div>
</div>